import { render } from "./view315Btn.vue?vue&type=template&id=29c5be45&scoped=true"
import script from "./view315Btn.vue?vue&type=script&lang=js"
export * from "./view315Btn.vue?vue&type=script&lang=js"

import "./view315Btn.vue?vue&type=style&index=0&id=29c5be45&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c5be45"]])

export default __exports__